import Alpine from "alpinejs";

const base =
    '<svg xmlns="http://www.w3.org/2000/svg" class="btn__icon" aria-hidden="true" focusable="false" role="img" fill="currentColor" viewBox="0 0 ';
const icons = {
    excel: `${base}384 512"><path d="M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM97.9 224L163 320 97.9 416h58L192 362.7 228.1 416h58L221 320l65.1-96h-58L192 277.3 155.9 224h-58z"/></svg>`,
    external: `${base}384 512"><path d="M302 96h32v32V352v32H270V352 205.3L68.6 406.6 46 429.3 .7 384l22.6-22.6L224.7 160H78 46V96H78 302z"/></svg>`,
    pdf: `${base}448 512"><path d="M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zm96-112h24c30.9 0 56 25.1 56 56s-25.1 56-56 56h-8v32 16H144V496 448 368 352h16zm24 80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48h8zm88-80h24c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H272 256V496 368 352h16zm24 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16h-8v96h8zm72-128h16 48 16v32H432 400v32h32 16v32H432 400v48 16H368V496 432 368 352z"/></svg>`,
    powerpoint: `${base}384 512"><path d="M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM136 208H112v24V336v56 24h48V392 360h44c42 0 76-34 76-76s-34-76-76-76H136zm68 104H160V256h44c15.5 0 28 12.5 28 28s-12.5 28-28 28z"/></svg>`,
    word: `${base}384 512"><path d="M48 464V48H224V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM114.7 224H65.3l47.5 189.8 4.5 18.2H136h8 18.4l4.8-17.7 24.8-92 24.8 92 4.8 17.7H240h8 18.7l4.5-18.2L318.7 224H269.3l-26 104L220 241.7 215.2 224H196.8h-9.6H168.8L164 241.7 140.7 328l-26-104z"/></svg>`,
    zip: `${base}384 512"><path d="M48 464V48h64V64h16 32 16V48h48V160H336V464H48zM256 0H48 0V48 464v48H48 336h48V464 128L256 0zM112 96v32h16 32 16V96H160 128 112zm0 64v32h16 32 16V160H160 128 112zM80 416H208V344L176 224H112L80 344v72zm48-80h32 16v32H160 128 112V336h16z"/></svg>`,
};

function extensioncheck(href, extensions) {
    return extensions.split(",").some((ext) => href.toLowerCase().endsWith(`.${ext}`));
}

Alpine.data("linkicon", (icon) => ({
    init() {
        this.$nextTick(() => {
            const link = this.$el;
            const target = this.$refs.icon || this.$el;
            const href = link.getAttribute("href");
            if (!href || icon) {
                return;
            }
            if (!icon) {
                if (extensioncheck(href, "pdf")) {
                    icon = "pdf";
                } else if (extensioncheck(href, "xlsx,xls")) {
                    icon = "excel";
                } else if (extensioncheck(href, "docx,doc")) {
                    icon = "word";
                } else if (extensioncheck(href, "zip,rar,gzip,tar.xz")) {
                    icon = "zip";
                } else if (extensioncheck(href, "pptx,ppt,key")) {
                    icon = "powerpoint";
                } else if (link.target) {
                    icon = "external";
                }
            }
            if (!icon || !icons[icon]) {
                return;
            }

            target.insertAdjacentHTML("beforeend", icons[icon]);
        });
    },
}));
